import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useExpenseSettingStore } from './expenseSettingStore.js';
export default {
  __name: 'LeanLawExpenseSetup',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    companyBillingState: {
      type: Object,
      required: true
    },
    expenseWizardState: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const leanLawExpenseSetup = reactive({
      data: {
        same: false
      }
    });
    const expenseSettingStore = useExpenseSettingStore();
    onMounted(async () => {
      leanLawExpenseSetup.data.same = props.expenseWizardState.data.same;
    });
    const different = () => {
      leanLawExpenseSetup.data.same = false;
      expenseSettingStore.data.same = false;
      props.expenseWizardState.data.same = false;
    };
    const same = () => {
      leanLawExpenseSetup.data.same = true;
      expenseSettingStore.data.same = true;
      props.expenseWizardState.data.same = true;
    };
    return (_ctx, _cache) => {
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, {
        class: "w-full h-full flex flex-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_row, {
          class: "pa-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            class: "pa-2",
            cols: "12"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("p", {
              class: "text-left"
            }, "Expenses Created in LeanLaw", -1), _createElementVNode("p", {
              class: "text-left"
            }, " These are expenses that don't have a corresponding \"Expense\" item in QuickBooks, sometimes called \"soft\" expenses--for example, copying, mileage, and general overhead charges.", -1), _createElementVNode("p", {
              class: "text-left"
            }, "Would you like these expenses to use a different account and service than your expenses synced from QuickBooks? Or should we use the Same settings? ", -1)]))]),
            _: 1
          }), _createVNode(_component_v_col, {
            class: "pa-2 flex flex-col",
            cols: "12"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              value: "next",
              class: "p-0 w-full mr-2 mb-2",
              color: !leanLawExpenseSetup.data.same ? 'primary' : undefined,
              onClick: _cache[0] || (_cache[0] = $event => different())
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Different ", -1)]))]),
              _: 1
            }, 8, ["color"]), _createVNode(LlSecondaryButton, {
              value: "done",
              color: leanLawExpenseSetup.data.same ? 'primary' : undefined,
              class: "p-0 w-full mb-2",
              onClick: _cache[1] || (_cache[1] = $event => same())
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Same ", -1)]))]),
              _: 1
            }, 8, ["color"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_row)]),
        _: 1
      });
    };
  }
};